import Buttons from '../Buttons/Buttons';
import style from './Calendar.module.css';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import '../../styles/CalendarPicker.css';
import { useEffect, useRef, useState } from 'react';
import { Russian } from 'flatpickr/dist/l10n/ru';
import { calculateEstimate, formatDurationWords, formatMoney } from '../../utils/utils';
import { Accordion, AccordionDetails, AccordionSummary, Slider } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function Calendar({
    date,
    setDate,
    orderLoading,
    startSlot,
    setStartSlot,
    durationMinutes,
    setDurationMinutes,
    sliderValue,
    setSliderValue,
    sliderTime,
    setSliderTime,
    orders,
    slots, setSlots,
    price, setPrice,
    setPriceList,
    kinoNight, setKinoNight,
    slotInterval,
    bufferTimeMs,
    people,
    filial,
    hall,
    etcLoading,
    changePage
}) {
    const [currentDateStr, setCurrentDateStr] = useState("");
    const calendarRef = useRef(null);
    const flatpickrInstance = useRef(null);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [reserved, setReserved] = useState(false);

    useEffect(() => {
        flatpickrInstance.current = flatpickr(calendarRef.current, {
            locale: Russian,
            inline: true,
            static: true,
            defaultDate: date,
            minDate: new Date(Date.now() + 3 * 60 * 60 * 1000),
            maxDate: new Date().setMonth(new Date().getMonth() + 1),
            onChange: (selectedDates) => {
                setDate(selectedDates[0]);
            }
        });

        return () => {
            if (flatpickrInstance.current) {
                flatpickrInstance.current.destroy();
            }
        };
    }, []);

    useEffect(() => {
        if (orders === null) return;
        setSlots(prevSlots => {
            const selectionEnd = startSlot + durationMinutes * 60 * 1000;
            const now = Date.now();
            const disableUntil = now + 3 * 60 * 60 * 1000;

            const updatedSlots = prevSlots.map(slot => {
                const slotStart = slot.start;
                const slotEnd = slot.start + slotInterval;

                // занято ли по заказам
                const taken = isSlotTaken(slotStart, slotEnd);

                // попадает ли в диапазон выбора
                const inSelectedRange = slotStart >= startSlot && slotEnd <= selectionEnd;

                const isReserved = inSelectedRange && taken;
                const isActive = inSelectedRange;

                // слоты буфера
                const isBuffered = !isReserved && !isActive && 
                    orders.some(order => {
                        const bufferedStart = order.start - bufferTimeMs;
                        const bufferedEnd = order.end + bufferTimeMs;
                        return slotStart >= bufferedStart && slotEnd <= bufferedEnd && 
                            (slotEnd <= order.start || slotStart >= order.end);
                    });

                const isTooEarly = slotStart < disableUntil;

                return {
                    ...slot,
                    isReserved,
                    isActive,
                    isBuffered,
                    isTaken: taken || isTooEarly
                };
            });

            updateTimeText(selectionEnd);
            return updatedSlots;
        });
    }, [startSlot, durationMinutes, slotInterval, orders]);

    useEffect(() => {
        if (orders && !orderLoading) scrollTo("text_info_start");
    }, [orderLoading]);

    useEffect(() => {
        setDurationMinutes(parseInt(sliderValue) || 60);
    }, [sliderValue]);

    useEffect(() => {
        let isValidate = true;

        if (!startSlot) isValidate = false;
        if (slots.filter(slot => slot.isReserved === true).length !== 0) {
            isValidate = false;
            setReserved(true);
        } else setReserved(false);

        setButtonDisabled(!isValidate);
    }, [startSlot, slots]);

    useEffect(() => {
        const hours = durationMinutes / 60;
        const start = (new Date(startSlot).getTime() / 1000);
        const end = start + (3600 * hours);
        const result = calculateEstimate(start, end, people, filial, hall);

        let totalPrice = 0;
        result.forEach(price => {
            totalPrice += price.rate * price.hours;
        });

        setPrice(totalPrice);
        setPriceList(result);

        const startTime = new Date(start*1000);
        const endTime = new Date(end*1000);
        
        if (startTime.getHours() === 0 && startTime.getMinutes() === 0 && endTime.getHours() === 9 && endTime.getMinutes() === 0) {
            if (filial === 2 && hall === 6) {
                if (people >= 11) setKinoNight(18000);
                else setKinoNight(15000);
            } else {
                if (people >= 5) setKinoNight(8500);
                else if (filial === 1) {
                    if (hall === 1 || hall === 2) setKinoNight(7500);
                    else if (hall === 3 || hall === 4 || hall === 5 || hall === 6) setKinoNight(7000);
                } else if (filial === 2) {
                    setKinoNight(7000);
                }
            }
        } else {
            setKinoNight(0);
        }
    }, [startSlot, durationMinutes]);

    function updateTimeText(end) {
        if (!startSlot || !end) return;

        const startStr = new Date(startSlot).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
        const endStr = new Date(end).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

        setSliderTime(`${startStr} - ${endStr}`);
    }

    function isSlotTaken(slotStart, slotEnd) {
        return orders.some(order => {
            const bufferedStart = order.start - bufferTimeMs;
            const bufferedEnd = order.end + bufferTimeMs;
            return !(slotEnd <= bufferedStart || slotStart >= bufferedEnd);
        });
    }

    const handleSlotClick = (slot) => {
        if (isSlotTaken(slot.start, slot.end)) return;
        if (startSlot === null) scrollTo("text_info_slider");
        setStartSlot(slot.start);
    };

    const click = () => {
        if (!buttonDisabled) changePage(5);
    }

    function scrollTo(element_id) {
        const element = document.getElementById(element_id);
        let scrollSleep = 0;
        if (!element) scrollSleep = 100;

        if (scrollSleep) {
            setTimeout(() => {
                const element = document.getElementById(element_id);
                element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, scrollSleep);
        } else {
            element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    return (
        <>
            <div className={style.calendar_container}>
                {!date && 
                    <div className={style.text_info}>Выберите день Вашего бронирования, нажав на нужную дату.</div>
                }
                <div ref={calendarRef} className={style.calendarFullWidth}></div>
            </div>
            {orders ? (
                <div className={style.container} id="time_container">
                    {!startSlot ? (
                        <div className={style.text_info} id="text_info_start">Выберите время начала Вашего бронирования, нажав на свободный слот.</div>
                    ) : (
                        <>
                            <div className={style.text_info} id="text_info_slider">
                                <p>Выберите длительность Вашего бронирования, передвигая слайдер (ползунок).</p>
                                <p>Минимальное время — 2 часа.</p>
                            </div>
                            <div className={style.price_block}>
                                <div className={style.time_value}>{sliderTime}</div>
                                {price && <div className={`${style.price} ${kinoNight !== 0 && style.kinoNight}`}>{formatMoney(price)} ₽</div>}
                                {kinoNight !== 0 && (
                                    <div className={style.kinoNight_block}>
                                        <div className={style.price}>{formatMoney(kinoNight)} ₽</div>
                                        <div className={style.kinoNight_text}>тариф "Кино-ночь"</div>
                                    </div>
                                )}
                            </div>
                            <Slider
                                min={120}
                                max={600}
                                step={30}
                                value={sliderValue}
                                onChange={(e) => setSliderValue(e.target.value)}
                                disabled={!startSlot}
                                valueLabelDisplay="on"
                                valueLabelFormat={formatDurationWords}
                                size="string"
                                className={style.slider}
                            />
                        </>
                    )}
                    {reserved && (
                        <div className={style.text_reserved}>Вы выбрали время, которое уже занято.</div>
                    )}
                    <div className={style.time_container}>
                        {slots.map((slot, index) => (
                            <button
                                key={index}
                                className={`${style.slot} 
                                    ${slot.isTaken ? style.deactive : ''}
                                    ${slot.isNextDay ? style.next_day_slot : ''}
                                    ${slot.isActive ? style.active : ''}
                                    ${slot.isReserved ? style.reserved : ''}
                                    ${slot.isBuffered ? style.deactive : ''}
                                `}
                                disabled={slot.isTaken}
                                data-timestamp={slot.start}
                                onClick={
                                    !slot.isTaken && !slot.isNextDay && !slot.isReserved && !slot.isBuffered 
                                        ? () => handleSlotClick(slot) 
                                        : () => {}
                                }
                            >
                                {slot.timeString}
                            </button>
                        ))}
                    </div>
                    <div className={style.accordion_block}>
                        <Accordion slotProps={{ heading: { component: 'h4' } }}>
                            <AccordionSummary
                                expandIcon={<KeyboardArrowDownIcon />}
                            >
                                <div className={style.accordion_title}>Что за квадратики?</div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className={style.info_container}>
                                    <div className={style.info_block}>
                                        <div className={`${style.slot}`}>00:00</div>
                                        <div className={style.info_block_text}>Свободное время</div>
                                    </div>
                                    <div className={style.info_block}>
                                        <div className={`${style.slot} ${style.active}`}>00:00</div>
                                        <div className={style.info_block_text}>Выбранное Вами время</div>
                                    </div>
                                    <div className={style.info_block}>
                                        <div className={`${style.slot} ${style.deactive}`}>00:00</div>
                                        <div className={style.info_block_text}>Занятое время</div>
                                    </div>
                                    <div className={style.info_block}>
                                        <div className={`${style.slot} ${style.next_day_slot}`}>00:00</div>
                                        <div className={style.info_block_text}>Время следующего дня</div>
                                    </div>
                                    <div className={style.info_block}>
                                        <div className={`${style.slot} ${style.reserved}`}>00:00</div>
                                        <div className={style.info_block_text}>Выбранное Вами время, которое уже занято</div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            ) : orderLoading ? (
                <div className={style.loading_container}>
                    <img src="/assets/img/logo3.gif" alt="Загрузка" className={style.gif} />
                </div>
            ) : ""}
            <Buttons 
                button1={{ text: "Далее", onClick: () => click(), disabled: buttonDisabled, loading: orderLoading }} 
                button2={{ text: "Назад", onClick: () => changePage(3) }} 
            />
        </>
    )
}